import script from "./UPersonItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./UPersonItem.vue?vue&type=script&setup=true&lang=ts"

import "./UPersonItem.vue?vue&type=style&index=0&id=2e486cbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e486cbe"]])

export default __exports__